import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const GetJobs = async (requestID) => {

  const accesstoken = getToken();
  if (accesstoken) {
    try {
      const response = await fetch(`${dev_baseUrl}/ServiceRequest/getJobRequest/${requestID}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
        
      if (response.ok && !data.isError) {   
        return data;
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const GetJobData = async (jobID) => {

  const accesstoken = getToken();
  if (accesstoken) {
    const queryParams = new URLSearchParams({
        workReqID: 0,
        jobMaterialID: 0,
        jobID: jobID,
    }).toString();

    try {
      const response = await fetch(`${dev_baseUrl}/JobMaterial/get?${queryParams}`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();
        
      if (response.ok && !data.isError) {   
        console.log('jobData', data)
      } else {
        console.error('Server error:', data);
        return [];
      }
    } catch (error) {
      console.error('Network error:', error);
      return [];
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};